<template>
    <div class="find-a-doctor-checkbox-filter">
        <input
            type="checkbox"
            class="checkbox"
            :checked="value"
            :id="`filter-${_uid}`"
            @change="handleChange"
        />
        <label
            class="label find-a-doctor-checkbox-filter__label"
            :for="`filter-${_uid}`"
            v-text="label"
            v-if="label"
        />
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
        },
        label: {
            type: String,
        },
    },
    methods: {
        handleChange(e) {
            this.$emit('input', e.target.checked)
        },
    },
}
</script>
